import {
    GET_LIST_OA
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    zalo_oa_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_OA: {
            return {
                ...state,
                zalo_oa_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
